import { ReactNode, createContext, useContext } from 'react';

import IProfile, { IProfilePublic } from '@/types/IProfile';

interface PreviewProfileContextType {
  previewProfile: IProfilePublic | IProfile | undefined;
}

const PreviewProfileContext =
  createContext<PreviewProfileContextType | null>(null);

export function PreviewProfileProvider({
  children,
  previewProfile,
}: {
  children: ReactNode;
  previewProfile: IProfilePublic | IProfile | undefined;
}) {
  return (
    <PreviewProfileContext.Provider value={{ previewProfile }}>
      {children}
    </PreviewProfileContext.Provider>
  );
}

export default function usePreviewProfile(): PreviewProfileContextType {
  const context = useContext(PreviewProfileContext);

  if (context === null) {
    throw new Error(
      'usePreviewProfile must be used within PreviewProfileProvider',
    );
  }

  return context;
}
